<ea-modal
	[size]="MODAL_SIZES.Large"
	[modalId]="externalModalId"
	[title]="constants.EXTERNAL_LINK_MODAL.TITLE"
	[clickOutsideClose]="false"
>
	<ng-template #modalBody>
		<ea-paragraph data-cy="external-navigation-modal-description">
			{{ constants.EXTERNAL_LINK_MODAL.BODY }}
		</ea-paragraph>
		<div
			class="external-url bold-text"
			data-cy="external-navigation-modal-institution"
		>
			{{ externalUrl }}
		</div>
		<ea-button-container
			[justification]="BUTTON_CONTAINER_JUSTIFICATION.Left"
			[alignment]="BUTTON_CONTAINER_ALIGNMENT.Horizontal"
		>
			<ea-button
				[isSubmit]="true"
				(onClick)="navigateToExternalUrl()"
				[type]="BUTTON_TYPES.Primary"
				name="launchExternalWebsite"
				title="Launch External Website"
				data-cy="external-navigation-modal-continue-button"
			>
				Continue
				<i class="fa fa-external-link" aria-hidden="true"></i>
			</ea-button>
			<ea-button
				[type]="BUTTON_TYPES.Secondary"
				(onClick)="closeModal()"
				class="btn-cancel"
				data-cy="external-navigation-modal-cancel-button"
				>Cancel</ea-button
			>
		</ea-button-container>
	</ng-template>
</ea-modal>
